import React from 'react';
import { Button } from './Button';
import { XIcon, MessageSquareIcon, PhoneIcon, HeartPulseIcon } from 'lucide-react';
interface HelpModeProps {
  onClose: () => void;
}
const HelpMode: React.FC<HelpModeProps> = ({
  onClose
}) => {
  // In a real app, this would navigate to the therapist chat
  const handleStartChat = () => {
    // Close the help modal first
    onClose();
    // Then navigate to the therapist chat
    // This would be handled through a router or state management in a real app
    setTimeout(() => {
      // Simulate navigation
      window.dispatchEvent(new CustomEvent('navigateToChat'));
    }, 100);
  };
  return <div className="fixed inset-0 bg-white bg-opacity-95 z-50 flex items-center justify-center p-4" data-id="element-447">
      <div className="w-full max-w-md bg-white border-2 border-gray-300 rounded-xl p-6 shadow-md" data-id="element-448">
        <div className="flex justify-between items-center mb-6" data-id="element-449">
          <h2 className="text-xl font-medium text-gray-800" data-id="element-450">Hulp nodig?</h2>
          <button onClick={onClose} className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 active:bg-gray-200 touch-manipulation" aria-label="Close" data-id="element-451">
            <XIcon className="w-5 h-5 text-gray-600" data-id="element-452" />
          </button>
        </div>
        <p className="text-gray-600 mb-6" data-id="element-453">
          We zijn er voor je. Kies een optie die bij je past.
        </p>
        <div className="space-y-4 mb-6" data-id="element-454">
          <Button variant="secondary" size="large" className="w-full justify-start" leftIcon={<MessageSquareIcon className="w-5 h-5" data-id="element-456" />} onClick={handleStartChat} data-id="element-455">
            Direct chatten met therapeut
          </Button>
          <Button variant="secondary" size="large" className="w-full justify-start" leftIcon={<PhoneIcon className="w-5 h-5" data-id="element-458" />} data-id="element-457">
            Afspraak maken (beeldbellen)
          </Button>
          <Button variant="secondary" size="large" className="w-full justify-start" leftIcon={<HeartPulseIcon className="w-5 h-5" data-id="element-460" />} data-id="element-459">
            Panic mode - snelle hulp
          </Button>
        </div>
        <div className="p-4 bg-gray-50 border-2 border-gray-300 rounded-lg" data-id="element-461">
          <p className="text-sm text-gray-600" data-id="element-462">
            <strong data-id="element-463">Belangrijk:</strong> Bij acute nood, bel altijd eerst 112 of
            de crisisdienst op 0800-1234.
          </p>
        </div>
      </div>
    </div>;
};
export default HelpMode;